<template>
    <div>
        <v-expansion-panels class="innerActsTable" flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" @click="Open()">
                    Список актов на подключение/отключение
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-data-table :loading="isLoading" :headers="headers" :items="items" disable-pagination disable-sort disable-filtering hide-default-footer>
                        <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                            <div :key="index" v-html="header.text"></div>
                        </template>
                        <template v-slot:item.act_number="{ item }">
                            <div>
                                <div>{{ item.act_number }}</div>
                                <div>{{ item.act_date }}</div>
                                <div class="py-4">{{ item.signed ? 'Документ подписан' : 'Документ не подписан' }}</div>
                                <div>
                                    <v-tooltip color="white" top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="printAct(item['act_rid'])" v-on="on" v-bind="attrs" small fab color="gray" outlined class="mr-3">
                                                <v-icon color="gray">local_printshop</v-icon>
                                            </v-btn>
                                        </template>
                                        <span class="tooltip-text">Распечатать</span>
                                    </v-tooltip>
                                    <v-tooltip color="white" top v-if="!item.signed">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="signAct(item['act_rid'])" v-on="on" v-bind="attrs" small fab color="gray" outlined class="mr-3">
                                                <v-icon color="gray">assignment</v-icon>
                                            </v-btn>
                                        </template>
                                        <span class="tooltip-text">Подписать</span>
                                    </v-tooltip>
                                    <v-tooltip color="white" top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click.stop="openEmailDialog(item)" v-on="on" v-bind="attrs" small fab color="gray" outlined class="mr-3"
                                                ><v-icon color="gray">mail</v-icon></v-btn
                                            >
                                        </template>
                                        <span class="tooltip-text">Отправить по электронной почте</span>
                                    </v-tooltip>
                                    <v-tooltip color="white" top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="deleteAct(item['act_rid'])" v-on="on" v-bind="attrs" small fab color="gray" outlined class="mr-3"
                                                ><v-icon color="gray">delete_forever</v-icon></v-btn
                                            >
                                        </template>
                                        <span class="tooltip-text">Удалить</span>
                                    </v-tooltip>
                                    <v-tooltip color="white" top v-if="item['eds_signed']">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="downloadDocument(item['guid'])" v-on="on" v-bind="attrs" small fab color="gray" outlined class="mr-3"
                                                ><v-icon color="gray">file_download</v-icon></v-btn
                                            >
                                        </template>
                                        <span class="tooltip-text">Скачать подпись</span>
                                    </v-tooltip>
                                    <v-tooltip color="white" top v-if="item['share']">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                @click="openWhatsAppDialog({ guid: item.guid, contacts: item.contacts })"
                                                v-on="on"
                                                v-bind="attrs"
                                                small
                                                fab
                                                color="gray"
                                                outlined
                                                class="mr-3"
                                                ><v-icon color="gray">share</v-icon></v-btn
                                            >
                                        </template>
                                        <span class="tooltip-text">Отправить по WhatsApp</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </template>
                        <template v-slot:item.action_name="{ item }">
                            <div>
                                <div>
                                    {{ item.serv_type_name }}
                                </div>
                                <div>
                                    {{ item.action_name }}
                                </div>
                                <div>
                                    {{ item.valid_begin }}
                                </div>
                                <div class="pt-3">
                                    {{ item.reason_name }}
                                </div>
                            </div>
                        </template>
                        <template v-slot:item.valid_begin="{ item }">
                            <div>
                                <div>Данные по предписанию</div>
                                <div>{{ item.reason_name }}</div>
                            </div>
                        </template>
                    </v-data-table>
                    <WhatsAppDialog @sendWhatsApp="$emit('sendWhatsApp', $event)" ref="whatsAppDialog" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>
<script>
import WhatsAppDialog from '@/components/ui/WhatsAppDialog';
export default {
    name: 'InnerActsTable',
    components: { WhatsAppDialog },
    props: {
        item: {
            required: true
        },
        isContract: {
            required: true
        }
    },
    inject: ['actsHeaders', 'getActsDetails', 'actDelete', 'actPrint', 'getSignedDocument', 'actSign'],
    data: function() {
        return {
            isOpen: false,
            items: [],
            headers: this.actsHeaders,
            isLoading: false,
            currentAct: null
        };
    },
    methods: {
        deleteAct(id) {
            this.actDelete(id);
        },
        printAct(id) {
            this.actPrint(id);
        },
        openEmailDialog(item) {
            this.$emit('openEmailDialog', true);
            this.$emit('openedAct', item);
        },
        async Open() {
            if (!this.isOpen) {
                this.isLoading = true;
                this.items = await this.getActsDetails(this.item);
                this.isLoading = false;
            }
            this.isOpen = !this.isOpen;
        },
        downloadDocument(guid) {
            this.getSignedDocument(guid);
        },
        signAct(id) {
            this.actSign(id);
        },
        openWhatsAppDialog({ guid, contacts }) {
            const moduleName = this.isContract ? 'act_documents/getContractsActPDFForCustomer' : 'act_documents/getAccountsActPDFForCustomer';
            this.$refs.whatsAppDialog.sendWhatsApp(guid, moduleName, contacts);
        }
    }
};
</script>

<style>
.innerActsTable .v-expansion-panel-content__wrap {
    padding: 0;
}
.innerActsTable .v-data-table th {
    background-color: #6b7bb2 !important;
}

.tooltip-text {
    color: #808080;
}
</style>
